export default "__VITE_ASSET__Bd2hr_4u__"